import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { createFlyingChipToChipSelector } from '@ezugi/bootstrap/src/components/ChipSelector/FlyingChips';
import { flyingChipsActions } from '@ezugi/bootstrap/src/store/reducers/flyingChips';
import { canPlaceBetsSelector, chipsSelector } from '@ezugi/bootstrap/src/store/selectors';

import { getChipByBetValue } from '../../components/Chip/utils';
import { winningBetsSelector } from '../../store/selectors/bets';

export const useFlyingChips = () => {
  const winningBets = useSelector(winningBetsSelector) as any[];
  const chips = useSelector(chipsSelector);

  const canPlaceBets = useSelector(canPlaceBetsSelector);

  const timeoutRef = useRef<number>();

  const dispatch = useDispatch();

  useEffect(() => {
    function handleVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        clearTimeout(timeoutRef.current);
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(
    () => {
      if (!winningBets.length || !canPlaceBets || document.visibilityState === 'hidden') {
        return;
      }

      timeoutRef.current = window.setTimeout(() => {
        const flyingChips = winningBets.map(({
          index, WinAmount,
        }) => {
          const flyingChip = createFlyingChipToChipSelector(
            WinAmount,
            getChipByBetValue(chips, WinAmount).img,
            index,
            26,
          );

          return flyingChip;
        });

        dispatch(flyingChipsActions.addFlyingChips(flyingChips));
      }, 500);

      // eslint-disable-next-line consistent-return
      return () => {
        clearTimeout(timeoutRef.current);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ winningBets, canPlaceBets, dispatch ]
  );
};
